import { DATE_FORMAT } from './../../../utils/constants';
import { CancelScheduleRequestModel } from './../../models/schedule/cancel.schedule.request.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import dayjs from 'dayjs';
import { Observable, tap } from 'rxjs';
import { API, environment } from '@core/envs';
import { OpenScheduleModel } from '../../models/schedule/open.schedule.model';
import { ScheduleModel } from '../../models/schedule/schedule.model';
import { ScheduledServicesModel } from '../../models/schedule/scheduledServicesModel';
import { ServiceStorage } from '../storage-service/service-storage.service';
import { SessionStorageService } from '../storage/session-storage.service';
import { StorageService } from '../storage/storage.service';
import { IPaymentToSchedule, IResponseModel } from '@core/interface';
import { OpenScheduleModelV2 } from '../../models/schedule/open.schedulev2.model';

@Injectable()
export class ScheduleService {
  constructor(private http: HttpClient) {}

  createSchedule(schedule: ScheduleModel, sessionStorage: StorageService, serviceStorage: ServiceStorage,
    session: SessionStorageService): Observable<IResponseModel<string>> {
    const api = environment.getRoute(API.transformation);
    const url = `${api}/schedules`;
    const openScheduleModel = new OpenScheduleModel(schedule, sessionStorage, serviceStorage, session);
    return this.http.post<IResponseModel<string>>(url, openScheduleModel);
  }

  createScheduleV2(schedule: ScheduleModel, sessionStorage: StorageService, serviceStorage: ServiceStorage,
    session: SessionStorageService, waitDealerShip: boolean): Observable<IResponseModel<any>> {
    const api = environment.getRoute(API.scheduling);
    const url = `${api}/schedules/create-schedule-workshop`;
    const openScheduleModel = new OpenScheduleModelV2(schedule, sessionStorage, serviceStorage, session, waitDealerShip);
    return this.http.post<IResponseModel<any>>(url, openScheduleModel);
  }

  createReschedule(
    schedule: ScheduleModel,
    sessionStorage: StorageService,
    serviceStorage: ServiceStorage,
    session: SessionStorageService,
    oldSchedule: ScheduledServicesModel | null,
    cancelUser: string,
    customerWaiting: boolean
  ): Observable<IResponseModel<string>> {

    const api = environment.getRoute(API.transformation);
    const url = `${api}/reschedule`;
    const openScheduleModel = new OpenScheduleModel(schedule, sessionStorage, serviceStorage, session, customerWaiting);

    let cancelRequest = null;
    if (oldSchedule) {
      cancelRequest = new CancelScheduleRequestModel(
        oldSchedule.divisionId,
        oldSchedule.country,
        oldSchedule.dealerId,
        oldSchedule.advisorId,
        oldSchedule.scheduleHour,
        dayjs(oldSchedule.scheduleDate).format(DATE_FORMAT),
        cancelUser,
        true // <-- isReschedule parameter
      );
    }

    const body = { newSchedule: openScheduleModel, cancelSchedule: cancelRequest };
    return this.http.put<IResponseModel<string>>(url, body);
  }

  cancelSchedule(
    schedule: ScheduledServicesModel | null,
    cancelUser: string,
    reschedule: boolean
  ): Observable<IResponseModel<any>> {
    const api = environment.getRoute(API.transformation);
    const url = `${api}/schedules`;

    let cancelRequest = null;
    if (schedule) {
      cancelRequest = new CancelScheduleRequestModel(
        schedule.divisionId,
        schedule.country,
        schedule.dealerId,
        schedule.advisorId,
        schedule.scheduleHour,
        dayjs(schedule.scheduleDate).format(DATE_FORMAT),
        cancelUser,
        reschedule
      );
    }

    return this.http.delete<IResponseModel<any>>(url, {body: cancelRequest});
  }

  saveScheduleReminderType(schedule: ScheduledServicesModel, chosenType: string): Observable<IResponseModel<any>> {
    const saveReminderType = {
      "division": 1,
      "country": schedule.country,
      "dealer": schedule.dealerId,
      "advisor": schedule.advisorId,
      "scheduleHour": schedule.scheduleHour,
      "scheduleDate": dayjs(schedule.scheduleDate).format(DATE_FORMAT),
      "touchType": chosenType,
    };

    const api = environment.getRoute(API.scheduling);
    const url = `${api}/schedules/touch`;

    return this.http.post<IResponseModel<any>>(url, saveReminderType);
  }

  getPickUpAndDeliveryScheduleHours(date: string, dealerId: number, country: string): Observable<any> {
    const api = environment.getRoute(API.dealer);
    const url = `${api}/services/pickup-delivery/hours?country=${country}&date=${date}&id=${dealerId}`;

    return this.http.get<any>(url);
  }


  getScheduledServices(vin: string, countryCode: string): Observable<IResponseModel<ScheduledServicesModel[]>> {
    const api = environment.getRoute(API.scheduling);
    const url = `${api}/schedules/v2/list`;

    const headers = {
      countryCode
    };

    return this.http.post<IResponseModel<ScheduledServicesModel[]>>(url, { vin, status: [1] }, { headers }).pipe(
      tap((response) => response)
    );
  }

  getPaymentUrl(dto: IPaymentToSchedule): Observable<IResponseModel<string>> {
    const api = environment.getRoute(API.payments);
    const url = `${api}/payment/url`;

    return this.http.post<IResponseModel<string>>(url, dto);
  }

}
